export const importNewList = {
	title: "Importar nova lista de convidados",
	secondTitle: "Importar lista nova ou existente",
	middleTitle: "Para importar uma nova lista basta fazer upload de uma planilha",
	format: "Formato da planilha",
	altText: "Exemplo de como a planilha a ser importada deve ser estruturada",
	sheetFileName: "Lista de convidados",
	errorMessageDefault:
		"Planilha inválida, baixe-a novamente e faça as alterações necessárias. Em caso de linhas vazias em vermelho, exclua e tente novamente.",
	importList: "Importe uma lista existente para este evento",
	selectText: "Importar lista do Local tal para este evento",
	relationUsers: "Clientes que serão adicionados a lista",
	error: "Erro",
	list: "Lista",
	message: "Mensagem",
	form: {
		listName: "Nome da lista",
		colorSelect: "Atribuir uma cor",
		expiresAtDate: "Expiração da lista",
		at: "às",
		errorName: "Informe o nome da lista",
		errorExpires: "Data e hora expirada.",
		couvertPercentage: "Desconto no couvert",
		entranceIds: {
			label: "Entrada associada",
			placeholder: "Selecione o tipo de entrada associada",
		},
		description: {
			label: "Descrição",
			placeholder: "Adicione uma observação para sua lista caso queira",
			limit: "Restam {{count}} caracteres",
		},
		documentIsRequired: "Documento é obrigatório",
		canBeInvitedByLink: "Compartilhamento de lista via link",
		addGuestTimeLimit: "Prazo limite de inserção de convidados",
	},
	successMessage: "Planilha importada com sucesso",
	alert:
		"Antes de importar a planilha, garanta que todas as linhas em branco sejam removidas",
	goBackText: "Voltar para listas",
	or: "ou",
	goBackModal: {
		title: "Sair",
		leavePage: "Sair da página",
		description:
			"Ao sair dessa página você perderá todas as informações preenchidas, deseja sair mesmo assim?",
	},
};
